module.exports = __webpack_public_path__ + "static/img/map.5e667b35.png";